const dateFormat = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });

/**
 * Takvim tarihi ("2026-10-09") → "9 Ekim 2026". `new Date("2026-10-09")` UTC gece yarısı
 * sayılır ve saat dilimine göre önceki güne kayabilir; parçalar yerel tarih olarak kurulur.
 */
export function formatDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-').map(Number);
  if (!year || !month || !day) return isoDate;
  return dateFormat.format(new Date(year, month - 1, day));
}

/** UTC zaman damgası ("2026-10-12T09:30:00Z") → ziyaretçinin saatine göre "12 Ekim 2026". */
export function formatDateFromTimestamp(isoDateTime: string): string {
  const date = new Date(isoDateTime);
  return Number.isNaN(date.getTime()) ? isoDateTime : dateFormat.format(date);
}
